import { render } from "./footer.vue?vue&type=template&id=fc2cade0&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=fc2cade0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc2cade0"

export default script